import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function SocialEvents() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="3397" className="elementor elementor-3397">
										<div className="elementor-element elementor-element-7087c03 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="7087c03" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-40cd365 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="40cd365" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="elementor-element elementor-element-ed2415d e-grid e-con-full wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="ed2415d" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-9750327 elementor-invisible elementor-widget elementor-widget-elementskit-image-box" data-id="9750327" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-image-box.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con">
																<div className="elementskit-info-image-box ekit-image-box text-center floating-style">


																	<div className="elementskit-box-header image-box-img-center">

																		<img decoding="async" src="/assets/uploads/elementor/thumbs/CNC05371-scaled-r2hwmv74s08xvd60arfbrrr8o6c7u7f9472lom7iuw.jpg" title="CNC05371" alt="CNC05371" loading="lazy" />
																	</div>

																	<div className="elementskit-box-body ekit-image-box-body">
																		<div className="elementskit-box-content ekit-image-box-body-inner">
																			<h3 className="elementskit-info-box-title">

																				Family Gatherings

																			</h3>
																		</div>

																		<div className="elementskit-box-footer">
																			<div className="box-footer">
																				<div className="btn-wraper">
																					<Link className="elementskit-btn whitespace--normal" to="/catering">
																						Explore more
																						<i aria-hidden="true" className="icon icon-arrow-right"></i>
																					</Link>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>				</div>
													</div>
													<div className="elementor-element elementor-element-20dda73 elementor-invisible elementor-widget elementor-widget-elementskit-image-box" data-id="20dda73" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-image-box.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con">
																<div className="elementskit-info-image-box ekit-image-box text-center floating-style">


																	<div className="elementskit-box-header image-box-img-center">

																		<img decoding="async" src="/assets/uploads/elementor/thumbs/carnival_theme_decoration-r0718qwz3mue8sqj8ls3xbktz1po3egfd2agbceg54.jpg" title="carnival_theme_decoration" alt="carnival_theme_decoration" loading="lazy" />
																	</div>

																	<div className="elementskit-box-body ekit-image-box-body">
																		<div className="elementskit-box-content ekit-image-box-body-inner">
																			<h3 className="elementskit-info-box-title">

																				Kids Special Parties

																			</h3>
																		</div>

																		<div className="elementskit-box-footer">
																			<div className="box-footer">
																				<div className="btn-wraper">
																					<Link className="elementskit-btn whitespace--normal" to="/kids-special-parties">
																						Explore more
																						<i aria-hidden="true" className="icon icon-arrow-right"></i>
																					</Link>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>				</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-87139b8 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="87139b8" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-e9c4eff e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="e9c4eff" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="elementor-element elementor-element-1b94006 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="1b94006" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-b215168 elementor-widget__width-inherit elementor-widget elementor-widget-elementskit-heading" data-id="b215168" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Events library</h2></div></div>				</div>
													</div>
													<div className="elementor-element elementor-element-5559dff elementor-arrows-position-outside elementor-pagination-position-outside elementor-widget elementor-widget-image-carousel" data-id="5559dff" data-element_type="widget" data-e-type="widget" data-settings='{"slides_to_show":"3","slides_to_scroll":"1","image_spacing_custom":{"unit":"px","size":30,"sizes":[]},"navigation":"both","autoplay":"yes","pause_on_hover":"yes","pause_on_interaction":"yes","autoplay_speed":5000,"infinite":"yes","speed":500,"image_spacing_custom_tablet":{"unit":"px","size":"","sizes":[]},"image_spacing_custom_mobile":{"unit":"px","size":"","sizes":[]}}' data-widget_type="image-carousel.default">
														<div className="elementor-widget-container">
															<div className="elementor-image-carousel-wrapper swiper" role="region" aria-roledescription="carousel" aria-label="Image Carousel" dir="ltr">
																<div className="elementor-image-carousel swiper-wrapper" aria-live="off">
																	<div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="1 of 4"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/images/01/Gathar_Easter-Boxd-Society-3-scaled-1.jpg" alt="Wedding catering event in Pune" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="2 of 4"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/images/01/WEDDING-EVENTS.jpg" alt="Wedding catering services in Pune" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="3 of 4"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/images/01/CATERING-SERVICE.jpg" alt="Buffet catering service in Pune" /></figure></div><div className="swiper-slide" role="group" aria-roledescription="slide" aria-label="4 of 4"><figure className="swiper-slide-inner"><img decoding="async" className="swiper-slide-image" src="/assets/images/01/corporate-events-detail-1.jpg" alt="Corporate event catering in Pune" /></figure></div>			</div>
																<div className="elementor-swiper-button elementor-swiper-button-prev" role="button" tabIndex="0">
																	<svg aria-hidden="true" className="e-font-icon-svg e-eicon-chevron-left" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M646 125C629 125 613 133 604 142L308 442C296 454 292 471 292 487 292 504 296 521 308 533L604 854C617 867 629 875 646 875 663 875 679 871 692 858 704 846 713 829 713 812 713 796 708 779 692 767L438 487 692 225C700 217 708 204 708 187 708 171 704 154 692 142 675 129 663 125 646 125Z"></path></svg>					</div>
																<div className="elementor-swiper-button elementor-swiper-button-next" role="button" tabIndex="0">
																	<svg aria-hidden="true" className="e-font-icon-svg e-eicon-chevron-right" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M696 533C708 521 713 504 713 487 713 471 708 454 696 446L400 146C388 133 375 125 354 125 338 125 325 129 313 142 300 154 292 171 292 187 292 204 296 221 308 233L563 492 304 771C292 783 288 800 288 817 288 833 296 850 308 863 321 871 338 875 354 875 371 875 388 867 400 854L696 533Z"></path></svg>					</div>

																<div className="swiper-pagination"></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-76c78fc e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="76c78fc" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-ba72719 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="ba72719" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="elementor-element elementor-element-ee22ad6 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="ee22ad6" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="e-con-inner">
														<div className="elementor-element elementor-element-ee6edd7 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="ee6edd7" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
																														<EnquiryHeading widgetElementId="989b153" />

																														<EnquiryForm widgetElementId="dd55995" />

														</div>
													</div>
												</div>
											</div>
										</div>
									</div>



								</div>
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default SocialEvents

